import InfoIcon from '@mui/icons-material/Info';

import { formatNumber } from '../../../../utils/global';
import CustomTooltip from '../../../common-components/CustomTooltip/CustomTooltip';

import '../styles/profile.scss';

import {
  fairFeeCalculation,
  formatFairFee,
} from '@Saral-Influencer-Marketing/saral-utils/dist/functions/formulas/fairFee';

export default function ProfileStatsCards({ userDetails, audienceCredebility, aov_factor, profile }) {
  const engagementRate = userDetails?.engagement_rate
    ? Number(userDetails?.engagement_rate)
    : profile?.engagement_rate
      ? Number(profile?.engagement_rate)
      : 0;
  const followers = userDetails?.followers
    ? Number(userDetails?.followers)
    : profile?.followers
      ? Number(profile?.followers)
      : 0;

  const avgViews = userDetails?.avg_reels_plays || userDetails?.avg_views;

  const fairFee = fairFeeCalculation({
    followers: followers ? Number(followers) : null,
    dieHardFans: profile?.cl_ratio ? Number(profile?.cl_ratio) * 100 : null,
    engagementRate: engagementRate ? Number(engagementRate) : null,
    aovFactor: aov_factor ? Number(aov_factor) : null,
    avgViews: avgViews ? Number(avgViews) : null,
  });
  return (
    <div className="profile-stats-container">
      <div className="profile-stats-row">
        <ProfileDetailCard
          name="Eng. Rate"
          value={engagementRate ? `${(engagementRate * 100)?.toFixed(2)}%` : '-'}
          info="What % of followers engage with content"
        />
        <ProfileDetailCard
          name="Avg. Likes"
          value={userDetails?.avg_likes ? formatNumber(userDetails?.avg_likes) : '-'}
          info="Avg. number of likes on posts"
        />
        <ProfileDetailCard
          name="Avg. Cmts."
          value={userDetails?.avg_comments ? formatNumber(userDetails?.avg_comments) : '-'}
          info="Avg. number of comments on posts"
        />
        <ProfileDetailCard
          name="PPP"
          value={
            !isNaN(userDetails?.paid_post_performance) ? Number(userDetails?.paid_post_performance).toFixed(4) : '0'
          }
          info="Paid post performance vs. Organic"
        />
      </div>
      <div className="profile-stats-row">
        <ProfileDetailCard name="Audience Qty." value="-" />
        <ProfileDetailCard
          name="Est. Fair Fee"
          value={followers ? formatFairFee(fairFee) : '-'}
          info="Estimated fair fee based on all metrics"
        />
        <ProfileDetailCard
          name="Total Views"
          value={userDetails?.total_views ? formatNumber(userDetails?.total_views) : '-'}
        />
        <ProfileDetailCard name="Avg Views" value={avgViews ? formatNumber(avgViews) : '-'} />
      </div>
      <div className="profile-stats-row">
        <ProfileDetailCard
          name="Diehard fans"
          value={audienceCredebility ? audienceCredebility?.toFixed(2) + '%' : '-'}
          info="% of likers most likely to act on your offer"
        />
        <ProfileDetailCard name="30 Days Reach" value="-" info="Reach in the last month" />
        <ProfileDetailCard name="30 Days Posts" value="-" info="Number of posts in the last month" />
        <ProfileDetailCard
          name="Avg Reel Plays"
          value={userDetails?.avg_reels_plays ? formatNumber(userDetails?.avg_reels_plays) : '-'}
          info="How many people watch reels"
        />
      </div>
    </div>
  );
}

const ProfileDetailCard = ({ name, value, info, label }) => {
  return (
    <div className="detail-card">
      <p className="detail-name">{name} </p>
      <p className="detail-value">
        {value}{' '}
        {info && (
          <CustomTooltip title={info} arrow sx={{ zIndex: 99 }}>
            <InfoIcon />
          </CustomTooltip>
        )}
      </p>
    </div>
  );
};
